import { lzIsArray } from "../services/LzType";

export default class PackageModel {

    constructor(model) {
        if (!model) {
            model = {};
        }

        this.id = model.id ? +model.id : 0;
        this.name = model.name ? model.name : '';
        this.summary = model.summary ? model.summary : '';
        this.price_per_month = model.price_per_month ? +model.price_per_month : 0;
        this.price_per_year = model.price_per_year ? +model.price_per_year : 0;
        this.is_active = typeof model.is_active === 'undefined' ? true : !!model.is_active;
        this.created_at = model.created_at ? model.created_at : '';
        this.updated_at = model.updated_at ? model.updated_at : '';
        this.deleted_at = model.deleted_at ? model.deleted_at : '';
    }

    static parseArray(data) {
        if (!lzIsArray(data)) {
            return [];
        }

        const out = [];
        for (const item of data) {
            out.push(new PackageModel(item));
        }

        return out;
    }

}
